import { InjectionToken } from '@angular/core';
import { ApplicationSettings } from '../models/applicationSettings';

export let SettingService = new InjectionToken<ApplicationSettings>('/assets/settings.json');